import React from "react"
import { useSolutionLevelReportExportContext } from "contexts/SolutionLevelReportExportContext"
import ReportableFieldSelectAnswerFiltersReportableFieldSelect from "./ReportableFieldSelectAnswerFiltersReportableFieldSelect"
import ReportableFieldSelectAnswerFiltersDetails from "./ReportableFieldSelectAnswerFiltersDetails"

const NewSolutionLevelReportExportFormReportableFieldSelectAnswerFilters = () => {
  const { reportableFieldSelectAnswerFilters } = useSolutionLevelReportExportContext()

  return (
    <div className="w-full">
      <ReportableFieldSelectAnswerFiltersReportableFieldSelect />
      {reportableFieldSelectAnswerFilters.length > 0 && (
        <div className="mt-4">
          <span className="block mb-4">Questions:</span>
          <div className="flex flex-col gap-4">
            {reportableFieldSelectAnswerFilters.map((filter) => (
              <ReportableFieldSelectAnswerFiltersDetails
                key={filter.reportableFieldId}
                reportableFieldId={filter.reportableFieldId}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default NewSolutionLevelReportExportFormReportableFieldSelectAnswerFilters
